/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type RecordReviewInput, type ReviewOutcome } from '@therapy/shared-validators';

import { apiClient } from './client.js';

export type { RecordReviewInput, ReviewOutcome };

/** A recorded clinical review (BRD M01 review workflow). */
export interface PlanReview {
  readonly id: string;
  readonly versionNo: number;
  readonly progressPct: number;
  readonly outcome: ReviewOutcome;
  readonly summary: string;
  readonly recommendations: string | null;
  readonly nextReviewDate: string | null;
  readonly reviewedByName: string | null;
  readonly reviewedAt: string;
}

/** A plan whose review date has fallen due (review worklist). */
export interface DuePlan {
  readonly id: string;
  readonly clientId: string;
  readonly clientName: string;
  readonly name: string;
  readonly programType: string | null;
  readonly reviewDate: string | null;
  readonly status: string;
  readonly progressPct: number;
}

export const reviewsApi = {
  async due(): Promise<readonly DuePlan[]> {
    const { data } = await apiClient.get<readonly DuePlan[]>('/itps/reviews/due');
    return data;
  },
  async list(planId: string): Promise<readonly PlanReview[]> {
    const { data } = await apiClient.get<readonly PlanReview[]>(`/itps/${planId}/reviews`);
    return data;
  },
  async record(planId: string, payload: RecordReviewInput): Promise<readonly PlanReview[]> {
    const { data } = await apiClient.post<readonly PlanReview[]>(
      `/itps/${planId}/reviews`,
      payload,
    );
    return data;
  },
};
